import React, {PureComponent, useEffect, useRef, useState} from 'react';
// #FOLD_BLOCK
import {
  ViewState,
  GroupingState,
  IntegratedGrouping,
  // Appointment,
  EditingState,
  IntegratedEditing,
} from '@devexpress/dx-react-scheduler';
// #FOLD_BLOCK
import {
  Scheduler,
  WeekView,
  DayView,
  Appointments,
  Toolbar,
  DateNavigator,
  ViewSwitcher,
  AllDayPanel,
  AppointmentTooltip,
  AppointmentForm,
  GroupingPanel,
  Resources,
  DragDropProvider,
} from '@devexpress/dx-react-scheduler-material-ui';
import { connectProps } from '@devexpress/dx-react-core';
import { styled, alpha } from '@mui/material/styles';
// import PriorityHigh from '@mui/icons-material/PriorityHigh';
// import LowPriority from '@mui/icons-material/LowPriority';
// import Lens from '@mui/icons-material/Lens';
// import Event from '@mui/icons-material/Event';
// import AccessTime from '@mui/icons-material/AccessTime';
import Paper from '@mui/material/Paper';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import classNames from 'clsx';

// import { priorities } from './demo-data/tasks';
// import { data as tasks } from './demo-data/grouping';

import { green, deepOrange, lightBlue } from '@mui/material/colors';

import { createAgendaShiftApplicationByUserId, getAgendaUser, shiftAppsByComId, shiftAppsByLoc, updateAgendaShiftApplication, usersByComId } from './queries';
import { AgendaUser, CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftApplicationByUserIdMutationVariables, CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables, GetAgendaUserQuery, 
        GetAgendaUserQueryVariables, 
        ModelSortDirection, 
        ShiftAppsByComIdQuery, 
        ShiftAppsByComIdQueryVariables, 
        ShiftAppsByLocQuery, 
        ShiftAppsByLocQueryVariables, 
        ShiftsByComIdQuery, 
        ShiftsByComIdQueryVariables, 
        UpdateAgendaShiftApplicationMutation, 
        UpdateAgendaShiftApplicationMutationVariables, 
        UpdateAgendaShiftMutation, 
        UpdateAgendaShiftMutationVariables, 
        UsersByComIdQuery,
        UsersByComIdQueryVariables} from '../../graphql/API';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useAuthContext } from '../../contexts/AuthContext';
import { Modal, Spinner, Button as Btn } from 'react-bootstrap';
import { Button, IconButton, TextField, Fab, Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Close, CalendarToday, Create, LocationOn, Add as AddIcon, Notes } from '@mui/icons-material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import useScheduleItems from '../services/ScheduleItems/ScheduleOpenItems'
import UserImage from '../../components/UserImage';
import AppointmentFormCustom from '../services/ScheduleItems/AppointmenFormCustom';
import { v4 as uuidv4 } from 'uuid';
import { format } from 'date-fns';
import i18n from '../../contexts/I18n';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
// import * as localization from 'devextreme/localization';
import { ViewSwitcher as ViewSwitcherBase} from "@devexpress/dx-react-scheduler";
// import CustomTimeTableCell from './components/CustomTimeTableCell';
// import CustomDayScaleCell from './components/CustomDayScaleCell';
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Pagination } from '@aws-amplify/ui-react';
import CustomModal from '../../components/Modals/CustomModal';
import { enUS, fr } from 'date-fns/locale';
import Sidebar from '../services/Sidebar/Sidebar';
import { useNotification } from '../../contexts/NotificationProvider';
import useNotificationStorageService from '../services/NotificationStorageService';
import { PUBLIC_ID, USERS_PER_PAGE } from '../../config';
import TopicNotificationService from '../services/TopicService';
import useDateService from '../services/DateService';
import { Toast, ToastContainer } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
// import { FaCalendarCheck } from "react-icons/fa6";
// import { FaCircleQuestion } from "react-icons/fa6";

const PREFIX = 'Schedulum-form';
// #FOLD_BLOCK
const classes = {
  addButton: `${PREFIX}-addButton`,
};
const StyledFab = styled(Fab)(({ theme }) => ({
  [`&.${classes.addButton}`]: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(4),
    transition: 'bottom 0.3s ease-in-out'
  },
}));

let priorities: any[] = [{ id: '', text: '', color: green },];

const grouping = [{
  resourceName: 'priorityId',
}];

const filterTasks = (items: any[], priorityId: string | number) => items.filter(task => (
  !priorityId || task.priorityId === priorityId
));

function utcWithoutAdjustment(dateString: string) {
  const localDate = new Date(dateString);
  const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
  return utcDate.toISOString().slice(0, 19) + ".000Z";
}

type Task = {
  title: string;
  info: string;
  role: string;
  priorityId: string;
  startDate: string;
  endDate: string;
  user?: string;
  location?: string;
  confirmed?: boolean;
  suspended?: boolean;
  accepted?: boolean;
  id?: string; // number
};

// type SchedulerState = {
//   currentDate: string;
//   currentViewName: string;
//   data: Task[];
//   currentPriority: string | number;
//   resources: any[];
// };

// const returnDates = (date: any) => {
//   const theDate = new Date(new Date(date).getTime() - ((TIMEZONE*60)*60000)); //new Date();
//   const setYesterday = theDate.setDate(theDate.getDate() - 2); // IMPORTANT TO GET shift on different days
//   const yesterday = new Date(setYesterday).toISOString().split('T')[0] + "T05:00:00.000Z"; // +5 fuseau horraire
//   const setTomorrow = theDate.setDate(theDate.getDate() + 4); // IMPORTANT TO GET shift on different days
//   const tomorrow = new Date(setTomorrow).toISOString().split('T')[0] + "T05:00:00.000Z"; // +5 fuseau horraire

//   return [yesterday, tomorrow];
// };

// hack for priority FIX SOON:
const firstPriority = [];

const SchedulerView = () => {
  // I18N
  const { t } = useTranslation();
  // PAGINATION
  const [pageTokens, setPageTokens] = React.useState([null]);
  const [totalPagination, setTotalPagination] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
  const [hasMorePages, setHasMorePages] = React.useState(true);
  const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
  const [usersState, setUsersState] = useState([]);
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // SERVICE
  const {sendTopicNotification} = TopicNotificationService();
  // DATE SERVICES
  const {getTIMEZONE, getDateTimeWithTimezone } = useDateService();
  const TIMEZONE = getTIMEZONE();
  // NOTIFICATION
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const {updateNotificationModelCount} = useNotificationStorageService();
  const openShiftCount = notificationContext?.openShiftCount;
  const setOpenShiftCount = notificationContext?.setOpenShiftCount;
  const openShiftAcceptedCount = notificationContext?.openShiftAcceptedCount;
  const setOpenShiftAcceptedCount = notificationContext?.setOpenShiftAcceptedCount;
  // DRAG & DROP
  // const [allowDrag, setAllowDrag] = useState(false);
  
  const { DayViewTimeTableCell, DayViewDayScaleCell, WeekViewTimeTableCell, 
    WeekViewDayScaleCell, AllDayCell, GroupingPanelCell, FlexibleSpace, TooltipContent, TooltipHeader, AppointmentFormContainerBasic } = useScheduleItems(priorities);
  const [language, setLanguage] = useState('en');
  // const [schedulerKey, setSchedulerKey] = useState(0);
  const formTargetRef = useRef<HTMLElement | null>(null);
  // const flexibleSpaceRef = useRef<any>(null);
  const [form, setForm] = useState({
    creatingForm: false,
    data: [],
    currentDate: '',
    confirmationVisible: false,
    editingFormVisible: false,
    deletedAppointmentId: undefined,
    editingAppointment: undefined,
    previousAppointment: undefined,
    addedAppointment: {},
    startDayHour: 0,
    endDayHour: 24,
    isNewAppointment: false,
    selectOptions: [],
    isMulti: false,
    removeConfirm: true,
    removePublic: false,
  });
  
  // const [toolTip, setToolTip] = useState({
  //   visible: false,
  // });

  const [state, setState] = useState({
  // this.state = {
    currentDate: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0], //new Date().toISOString().split("T")[0],
    currentViewName: "Day",
    data: [] as Task[],
    currentPriority: 0 as number | string, //number 0 only to fix the default priotity for all the shifts
    resources: [
      {
        fieldName: "priorityId",
        title: "Priority",
        instances: priorities,
      },
    ],
  });

  const refreshList = (items: any) => {
    const newTasks = items.map((shift: any) => ({
      title: shift.info,
      info: shift.info,
      role: shift.role,
      user: shift.user,
      userId: shift.userId,
      username: shift.username,
      location: shift.location,
      confirmed: shift.confirmed,
      suspended: shift.suspended,
      accepted: shift.accepted,
      priorityId: shift.location,
      startDate: shift.startAt.split('.')[0],
      endDate: shift.stopAt.split('.')[0],
      id: shift.shiftAppId,
    })).flat();

    setState((prevState) => ({...prevState, data: newTasks }));
    setForm((prevForm) => ({...prevForm, data: newTasks }));
    // console.log('STATE',state);
    // flexibleSpace.update();

    return newTasks;
  };

  const {userId: AuthUserId} = useAuthContext();
  // console.log(AuthUserId);

  const {data: dataUser, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  // const [fetchDataUsersCount, {data: dataUsersCount, loading: loadingUsersCount, error: errorUsersCount, 
  //     refetch: refetchUsersCount, fetchMore: fetchMoreUsersCount}] = useLazyQuery
  //     <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
      
  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
      refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
      <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
  
  // const getTheDate = returnDates(new Date());
  // const yesterday = getTheDate[0];
  // const tomorrow = getTheDate[1];
  // console.log('yrst',yesterday);
  // console.log('tomorro', tomorrow);

  const [fetchData, {data: dataShift, loading: loadingShift, error: errorShift, 
    refetch: refetchShift, fetchMore: fetchMoreShift}] = useLazyQuery
    <ShiftAppsByComIdQuery, ShiftAppsByComIdQueryVariables>(shiftAppsByComId);

  const [fetchLocData, {data: dataLocShift, loading: loadingLocShift, error: errorLocShift, 
    refetch: refetchLocShift, fetchMore: fetchMoreLocShift}] = useLazyQuery
    <ShiftAppsByLocQuery, ShiftAppsByLocQueryVariables>(shiftAppsByLoc);

  const [doUpdateShift, {data: dataShiftAppUpdate, loading: loadingShiftAppUpdate, 
    error: eorrorShiftAppUpdate}] = useMutation
    <UpdateAgendaShiftApplicationMutation, UpdateAgendaShiftApplicationMutationVariables>(updateAgendaShiftApplication);

  const [doCreateShift, {data: dataShiftCreate, loading: loadingShiftCreate, 
    error: eorrorShiftCreate}] = useMutation
    <CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftApplicationByUserIdMutationVariables>(createAgendaShiftApplicationByUserId);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  // to reload each time
    useEffect(() => {
      setNotificationCount((notificationCount ?? 0) - 
        (openShiftCount ?? 0) - (openShiftAcceptedCount ?? 0));
      updateNotificationModelCount('openShift', 0);
      updateNotificationModelCount('openShiftAccepted', 0);
      setOpenShiftCount(0);
      setOpenShiftAcceptedCount(0);
  }, [location]);

  useEffect(() => {
    const savedLang = Cookies.get('language');
    if (savedLang !== language) {
      // console.log('LANG', savedLang);
      i18n.changeLanguage(savedLang);
      setLanguage(savedLang);
    }
  }, [i18n, t]);

  const priorityChange = (value: string) => {
    const { resources } = state;
    const filteredPriorities = priorities.filter((p) => p.id === value);
    // const val = parseInt(value);
    // let worker = [];
    // if (priorities[1]) {
    //   priorities.map((p) => {
    //     if (p.id === value) {
    //       worker = [p];
    //     }
    //   })
    // } else {
    //   worker = priorities[0];
    // }
    // console.log('value1', priorities);
    const nextResources = [
      {
        ...resources[0],
        // instances: val > 0 ? [priorities[val - 1]] : priorities,
        instances: value != '0' ? filteredPriorities : priorities,
        // instances: value != '0' ? [worker] : priorities,
      },
    ];
    setState((prevState) => ({...prevState, currentPriority: value, resources: nextResources }));
    // flexibleSpace.update();
  };

  // const FlexibleSpaceWithIcons = (props: any) => {
  //   return (
  //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px' }}>
  //       <FaCalendarCheck size={40} color="white" style={{
  //         backgroundColor: 'rgb(17, 135, 150)',
  //         borderRadius: 80, padding: '10px'
  //       }} />
  //       <FaCircleQuestion size={40} color="white" style={{
  //         backgroundColor: 'rgb(129, 135, 240)',
  //         borderRadius: 80, padding: '10px'
  //       }} />
  //       <FlexibleSpace {...props} /> {/* Garder le reste de la Toolbar */}
  //     </div>
  //   );
  // };

  const flexibleSpace = connectProps(FlexibleSpace, () => { // FlexibleSpaceWithIcons, 
  // const flexibleSpace = connectProps(FlexibleSpaceWithIcons, () => { 

    // const { currentPriority } = state;
    
    return {
        priority: state.currentPriority,
        priorityChange: priorityChange,
    };
  });

  // const componentDidUpdate = () => {
  //   flexibleSpace.update(); // #IMPORTANT_LINE
  // };

  const user = dataUser?.getAgendaUser;

  // const getUsers = async (token: string) => { //date: Date, 
  //   if (user?.comId) {
  //     return await fetchDataUsers({
  //       variables: {
  //         comId: user?.comId,  
  //         limit: USERS_PER_PAGE,               
  //         nextToken: token,  
  //         sortDirection: ModelSortDirection.ASC,
  //         filter: {
  //           suspended: {eq : false},
  //         }
  //         // sortDirection: ModelSortDirection.DESC,
  //       },
  //     });
  //   }
  // }
  
  // useEffect(() => {
  //   if (dataUser && !loading) {
  //     getUsers(pageTokens[pageTokens.length - 1]);
  //     // console.log("USERS ->", users);
  //   }
  // }, [dataUser, loading]); //, fetchDataUsers, pageTokens]);

//   useEffect(() => {
//     if (dataUsers && dataUsers.usersByComId && !dontUpdateAnymore) {
//       const newUsers = dataUsers.usersByComId.items;
//       const newToken = dataUsers.usersByComId.nextToken;
 
//       setUsersState(newUsers); // Met à jour la liste des utilisateurs
//       if (newToken) {
//         setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
//         setHasMorePages(true);
//       } else {
//         setHasMorePages(false); // Pas de token suivant, fin de la pagination
//       }
//     }
//   }, [dataUsers]);

//   useEffect(() => {
//     if (hasMorePages) {
//       setTotalPagination(pageTokens.length);
//     } else {
//       setTotalPagination(pageTokens.length - 1);
//     }
//   },[hasMorePages]);

//   const handlePageChange = async (pageIndex: any) => {
//     setDontUpdateAnymore(true);
//     setCurrentPageIndex(pageIndex);

//     const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
//     if (selectedToken !== undefined) {
//       const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(selectedToken);

//       if (newUsers.length !== 0) {
//         setUsersState(newUsers);
//         USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
//         if (newNextToken && !pageTokens.includes(newNextToken)) {
//           setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
//         }
//         // console.log(pageTokens);
//       } else {
//         if (hasMorePages) {
//           setHasMorePages(false);
//         }
//       }
//     }
//   };

//   const handleNextPage = async () => {
//     setDontUpdateAnymore(true);
//     // if (hasMorePages) {
//       // const nextToken = pageTokens[pageTokens.length - 1]; // Dernier token actuel
//       const nextToken = pageTokens[currentPageIndex];

//       if (nextToken) {
//         const { data: { usersByComId: { items: newUsers, nextToken: newNextToken } } } = await getUsers(nextToken);

//         if (newNextToken) {
//           setUsersState(newUsers);
//           USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
//           // console.log('allo');
//           if (!pageTokens.includes(newNextToken)) {
//               setPageTokens((prevTokens) => [...prevTokens, newNextToken]); // Ajoute le nouveau token
//           }
//           setCurrentPageIndex(currentPageIndex + 1);
//         } else {
//           if (newUsers.length > 0) {
//             setUsersState(newUsers);
//             USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
//             setCurrentPageIndex(currentPageIndex + 1);
//             // removeLastPagination();
//             setHasMorePages(false);
//           } else {
//             if (hasMorePages) {
//               // removeLastPagination();
//               setHasMorePages(false);
//             }
//           }
//           // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
//         }
//         // console.log(pageTokens);

//         // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
//       } else {
//         console.error("Next token is undefined or null");
//       }
//     // }
//   };

//   const handlePreviousPage = async () => {
//     if (currentPageIndex > 1) {
//       const prevToken = pageTokens[currentPageIndex - 2];
//       const { data: { usersByComId: { items: prevUsers, nextToken: newNextToken } } } = await getUsers(prevToken);

//       setUsersState(prevUsers);
//       // setPageTokens(pageTokens.slice(0, -1)); 
//       // if (hasMorePages) {
//       //  setHasMorePages(nextToken ? true : false);
//       // }
//       USERS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
//       setCurrentPageIndex(currentPageIndex - 1);
//     }
// };

//   const users = usersState;//dataUsers?.usersByComId?.items;
  // const usersCount = dataUsersCount?.usersByComId?.items;

  // useEffect(() => {
  //   // priorityChange(0);
  //   if (users) {
  //     // priorities = []; // dont work
  //     // priorities.length = 0; // dont work
  //     // console.log('PRIO', priorities);o
  //     priorities.splice(0, priorities.length);
  //     priorities.push({ id: PUBLIC_ID, text: "PUBLIC", color: green });
  //     users.forEach(user => {
  //       priorities.push({ id: user.userId, text: user.username, color: green })
  //     });

  //     setState(prevState => ({
  //       ...prevState,
  //       currentPriority: 0, // ou la priorité par défaut
  //       resources: [{
  //         fieldName: "priorityId",
  //         title: "Priority",
  //         instances: priorities,
  //       }],
  //     }));
  //   }
  // }, [users]);

  useEffect(() => {
    // console.log('shift6', state.currentPriority);
    if (user) {
      // console.log('TTTTTT');
        const usr = dataUser?.getAgendaUser;
        const theDate = new Date(state.currentDate);
        const sDate = theDate.setDate(theDate.getDate() - (state.currentViewName == "Day" ? 2 : 7));
        const startDate = new Date(getDateTimeWithTimezone(new Date(sDate).toISOString(), TIMEZONE*-1)).toISOString();
        // alert(startDate);
        const eDate = theDate.setDate(theDate.getDate() + (state.currentViewName == "Day" ? 5 : 14));
        const endDate = new Date(getDateTimeWithTimezone(new Date(eDate).toISOString(), TIMEZONE*-1)).toISOString();
        if (usr?.comId) {
          // console.log('shift5', state.currentPriority);
          // console.log('shift999', startDate + " " + endDate);
          if (state.currentPriority === 0) {
            fetchData({variables: {
              comId: usr?.comId,
              startAt: {gt: startDate},
              filter: {
                // startAt: {gt: startDate},//state.currentDate},
                stopAt: {lt: endDate},
                // confirmed: {eq: true},
                suspended: {eq : false},
                deleted: {ne: true}
                }
            }});
          } else {
            fetchLocData({variables: {
              // comId: usr?.comId,
              location: state.currentPriority.toString(),
              startAt: {gt: startDate},
              filter: { 
                comId: {eq: usr?.comId},
                // startAt: {gt: startDate},//state.currentDate},
                stopAt: {lt: endDate},
                // confirmed: {eq: true},
                suspended: {eq : false},
                deleted: {ne: true}
                }
            }});
            // shifts = dataLocShift.shiftAppsByLoc.items;
          }
          // fetchData({variables: {
          //   comId: usr?.comId, 
          //   startAt: {gt: startDate},//state.currentDate},
          //   filter: { 
              
          //     stopAt: {lt: endDate},
          //     // confirmed: {eq: true},
          //     suspended: {eq : false},
          //     deleted: {ne: true}
          //     }
          // }});
        }
        // console.log('shift1', shifts);
        // shifts = dataShift?.shiftsByComId?.items;
        // if (shifts) {
        //   console.log('shift12');
        //   refreshList(shifts);
        // }
    }
  }, [dataUser, loading, fetchData, state.currentDate, state.currentViewName, state.currentPriority]); //dataUsers

  let shifts = dataShift?.shiftAppsByComId?.items;
  // console.log('shift2', shifts);
  // console.log('shift3', form.data);
  // console.log('shift4', state.currentPriority);

  useEffect(() => {
    if (shifts && !loadingShift) {
      refreshList(shifts);

      priorities.splice(0, priorities.length);
      if (shifts.length == 0) priorities.push({ id: PUBLIC_ID, text: "PUBLIC", color: green });
      const uniqueShifts = shifts.filter((shift, index, self) =>
        index === self.findIndex(s => s.location === shift.location)
      );
      uniqueShifts.forEach(shift => {
        priorities.push({ id: shift.location, text: shift.location, color: green })
      });

      setState(prevState => ({
        ...prevState,
        currentPriority: 0, // ou la priorité par défaut
        resources: [{
          fieldName: "priorityId",
          title: "Priority",
          instances: priorities,
        }],
      }));
    }
  }, [loadingShift, shifts]);//, state.currentDate, state.currentViewName]);
  
  useEffect(() => {
    // alert('lol');
    flexibleSpace.update();
    
  }, [state]);

  // hack pour aria-hidden
  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (rootDiv) {
      rootDiv.removeAttribute("aria-hidden");
      // rootDiv.setAttribute("inert", "true"); // ✅ Ajoute inert au lieu d’aria-hidden
    }
    document.title = t('title.scheduler');

    const adjustPosition = () => {
      const element = document.querySelector(`.${classes.addButton}`) as HTMLElement | null;
      if (!element) return;
  
      const windowHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      const elementHeight = element.offsetHeight;
  
      const bottomLimit = 200;
      const maxBottom = scrollHeight - (windowHeight - elementHeight) - bottomLimit;
  
      if (window.scrollY >= maxBottom) {
        element.style.bottom = `${bottomLimit}px`;
      } else {
        element.style.bottom = '20px';
      }
    };
  
    window.addEventListener('scroll', adjustPosition);
  
    return () => {
      window.removeEventListener('scroll', adjustPosition);
    };
  }, []);

  if (!shifts || !state?.resources[0]?.instances[0]?.text) { // solve the loading (GROUPING) problem
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };
  // if (error || !user) {
  //   return console.log({
  //     key: `error_${user?.userId}`, 
  //     title: "Error fetching the user", 
  //     message: error?.message || "User not found",
  //     // onRetry: () => refetch()
  //   });
  // };
  // if (error || !user) {
  //   return console.log('ALLLLLO' + error?.message || "User not found");
  // };
  const truncate = (str: string | undefined, maxlength: number) => {
    if (str) {
      return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
    } else {
      return str;
    }
  };

  const currentViewNameChange = (currentViewName: string) => {
    setState((prevState) => ({...prevState, currentViewName }));
  };

  const currentDateChange = (currentDate: Date) => {
    const formattedDate = currentDate.toISOString().split('T')[0]; // Convert Date to YYYY-MM-DD
    setState((prevState) => ({...prevState, currentDate: formattedDate }));
  };

  const Appointment = ({
    children, style, ...restProps
  }: any) => (
    <Appointments.Appointment
      {...restProps}
      style={{ 
        ...style,
        backgroundColor: restProps.data.confirmed ? '#118796' : '#8187f0', //'#FFC107',
        borderRadius: '8px',
      }}
      // style={allowDrag(restProps.data) ? { 
      //   ...style,
      //   backgroundColor: restProps.data.confirmed ? '#118796' : '#8187f0', //'#FFC107',
      //   borderRadius: '8px',
      // }
      // : {backgroundColor: "#666", cursor: 'not-allowed'}}
      draggable={allowDrag(restProps.data) ? true : false}
      isShaded
      // appointmentType={'vertical'}//{'horizontal'}
    >
      {/* {children} */}
      <div style={{ padding: '8px', color: 'white'}}>
        {/* Afficher le titre du rendez-vous */}
        <strong>{restProps.data.role || 'Rendez-vous sans titre'}</strong>
        
        {/* Afficher la description du rendez-vous */}
        {restProps.data.location && <p><em>Lieu: {restProps.data.location}</em></p>}

        {/* Afficher l'heure de début et l'heure de fin */}
        {restProps.data.startDate && restProps.data.endDate && (
          <p>{`${format(new Date(restProps.data.startDate), "H:mm")} - ${format(new Date(restProps.data.endDate), "H:mm")}`}</p>
        )}

        {/* Afficher d'autres détails */}
        {/* {children} */}
      </div>
      {/* title: shift.info,
      role: shift.role,
      user: shift.user,
      location: shift.location,
      confirmed: shift.confirmed,
      suspended: shift.suspended,
      accepted: shift.accepted,
      priorityId: shift.userId,
      startDate: shift.startAt,
      endDate: shift.stopAt,
      id: shift.shiftAppId, */}
    </Appointments.Appointment>
  );

  // AppointmentForm & it's functions
  const onEditingAppointmentChange = (editingAppointment: any) => {
    setForm((prevState) => ({...prevState, 
      editingAppointment: editingAppointment
    }));
  }

  const onAddedAppointmentChange = (addedAppointment: any) => {
    setForm((prevState) => ({...prevState, addedAppointment }));
    if (form.editingAppointment !== undefined) {
      setForm((prevState) => ({...prevState, previousAppointment: form.editingAppointment }));
    }
    setForm((prevState) => ({...prevState, editingAppointment: undefined, isNewAppointment: true }));
  }

  const commitChanges = ({ added, changed, deleted }: any) => {
    // console.log("Commit Changes Triggered:", { added, changed, deleted });
    // dragAndDropChanges({ added, changed, deleted });
    // setForm((state) => {
    //   let { data } = state;
    //   if (added) {
    //     const startingAddedId = data.length > 0 ? data[data.length - 1].id + 1 : 0;
    //     data = [...data, { id: startingAddedId, ...added }];
    //   }
    //   if (changed) {
    //     data = data.map(appointment => (
    //       changed[appointment.id] ? { ...appointment, ...changed[appointment.id] } : appointment));
    //   }
    //   if (deleted !== undefined) {
    //     setDeletedAppointmentId(deleted);
    //     toggleConfirmationVisible();
    //   }
    //   return { data, addedAppointment: {} };
    // });
  }
  const dragAndDropChanges = ({ added, changed, deleted }: any) => {
    // console.log("Drag and Drop Changes:", { added, changed, deleted });
    setState((prevState) => {
      let { data } = prevState;
    
      if (added) {
        // Générer un nouvel ID unique sous forme de string
        const newId = generateCustomId(); //`-${data.length + 1}`;
        data = [...data, { id: newId, ...added }];
      }
    
      if (changed) {
        data = data.map(appointment =>
          changed[appointment.id] ? { ...appointment, ...changed[appointment.id] } : appointment
        );
        const id = Object.keys(changed)[0];
        // console.log('CH', changed[id])
        // const worker = users.filter((user) => changed[id].priorityId === user.userId);
        // verifyUpdate(changed, shift);
        verifyUpdate(changed, changed[id].priorityId);
      }
    
      if (deleted !== undefined) {
        data = data.filter(appointment => appointment.id !== deleted);
      }
    
      return { ...prevState, data };
    });
  }

  const toggleEditingFormVisibility = () => {
    // const { editingFormVisible } = this.state;
    setForm((prevForm) => ({...prevForm, editingFormVisible: !form.editingFormVisible}));
  }

  const toggleConfirmationVisible = () => {
    setForm((prevState) => ({...prevState, confirmationVisible: !form.confirmationVisible }));
  }

  const commitDeletedAppointment = () => {
    const nextData = form.data.filter(appointment => appointment.id !== form.deletedAppointmentId);
    // setForm((prevState) => ({...prevState,
    //   const nextData = form.data.filter(appointment => appointment.id !== form.deletedAppointmentId);

    //   return { data: nextData, deletedAppointmentId: null };
    // });
    return { data: nextData, deletedAppointmentId: undefined as string | undefined };
    toggleConfirmationVisible();
  }

  const deleteShift = async (appointment: any) => {
    try {
      await doUpdateShift({variables: {input: {
        shiftAppId: appointment.id,
        suspended: true,
        deleted: true,
      }}});

      setToastStatus("bg-danger");
      setToastTitle('');
      setToastMessage(t('toast.openShiftDeleted'));
      setShowToast(true);

      setShowCustomModal(false);
      refetchShift();
    } catch (error) {
      console.log('error', (error as Error).message);
    }    
  };

  const verifyDeleteShift = (app: any, tooltip: boolean = false) => {
    if (tooltip) {
      removeToolTip();
    }
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('shift.deleteTitle')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{t('shift.deleteMessage')}</p>
          </Modal.Body>
          <Modal.Footer>
            <Btn variant="secondary" onClick={() => setShowCustomModal(false)}>
              {t('shift.cancel')}
            </Btn>
            <Btn variant="primary" onClick={ () => deleteShift(app)}>
              {t('shift.delete')}
            </Btn>
          </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const updatingShift = async (event: any) => {
    console.log('allo', event)
    if (event.deleted) {
      const app = {id: event.deleted}
      verifyDeleteShift(app);
      return
    }
    // console.log('EVENT', event);
    // return
    const id = Object.keys(event.changed)[0];
    // console.log("ID", id);
    if (id) { 
      try {
        const userId = event.changed[id].users ? event.changed[id].users[0].id : event.changed[id].userId;
        // console.log('USR', userId);
        const info = event.changed[id].info;
        const role = event.changed[id].role;
        const location = event.changed[id].location;
        const confirmed = event.changed[id].confirmed;
        // const userId = event.changed[id].priorityId;
        const startDate = utcWithoutAdjustment(new Date((event.changed[id].startDate)).toString()); //.toISOString().slice(0, 19) + ".000Z";
        const endDate = utcWithoutAdjustment(new Date((event.changed[id].endDate)).toString()); //.toISOString().slice(0, 19) + ".000Z";

        const confirmedDate = startDate.split("T")[0]+"12:00:00.000Z";

        // console.log('SD',new Date((event.changed[id].startDate.toString())));
        // console.log('SD',startDate);
        // console.log('ED',endDate);
        await doUpdateShift({variables: {input: {
          shiftAppId: id,
          userId: userId,
          role: truncate(role, 150),
          info: truncate(info, 150),
          location: truncate(location, 150),
          confirmed: false, // confirmed
          startAt: startDate,
          stopAt: endDate,
        }}});
        // sendTopicNotification(role ?? undefined, location ?? undefined, user.FCMtoken ?? undefined, userId ?? undefined, id ?? undefined, startDate, endDate, "openShift");
        // alert(location);
        setToastStatus("bg-success");
        setToastTitle('');
        setToastMessage(t('toast.openShiftUpdated'));
        setShowToast(true);
        refetchShift();
      } catch (error) {
        console.log('error', (error as Error).message);
      }    
    } else {
      alert('Shift update failed');
    }
  }

  const updatingDragAndDRapShift = async (event: any) => {
    const id = Object.keys(event)[0];
    if (id) { 
      try {
        // const userId = event[id].priorityId;
        const startDate = utcWithoutAdjustment(new Date((event[id].startDate)).toString()); 
        const endDate = utcWithoutAdjustment(new Date((event[id].endDate)).toString());
        await doUpdateShift({variables: {input: {
          shiftAppId: id,
          // userId: userId,
          // username: username,
          startAt: startDate,
          stopAt: endDate,
        }}});
        setShowCustomModal(false);
        refetchShift();
      } catch (error) {
        console.log('error', (error as Error).message);
      }    
    } else {
      alert('Shift update failed');
    }
  }

  const getLanguage = () => {
      switch (language) {
        case 'en':
          return enUS
        case 'fr':
          return fr
        default:
          return enUS
      }
    }

  const verifyUpdate = (data: any,location: any[]) => {
    const id = Object.keys(data)[0];
    setFooterModal(false);
    setContentModal(<>
      <Modal.Header>
        <Modal.Title>{t('shift.dragUpdateTitle')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <h5>{location}</h5>
            <p>{t('shift.dragUpdateStartAt')}{format(new Date(data[id].startDate), "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
            <p>{t('shift.dragUpdateStopAt')}{format(new Date(data[id].endDate), "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
          </Modal.Body>
          <Modal.Footer>
            <Btn variant="secondary" onClick={() => setShowCustomModal(false) }>
              {t('shift.cancel')}
            </Btn>
            <Btn variant="primary" onClick={ () => updatingDragAndDRapShift(data)}>
              {t('shift.rankUpdate')}
            </Btn>
          </Modal.Footer>
      </>);
      setShowCustomModal(true);
  }

  const generateCustomId = () => {
    const prefix = "ShiftApp"; // "ShiftApp";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
  };

  const shiftCreation = async (id: any, data: any, usr: any) => {
    try{
      const startAt = utcWithoutAdjustment(new Date(data.startDate).toString());
      const stopAt = utcWithoutAdjustment(new Date(data.endDate).toString());
      await doCreateShift({variables: {
        shiftAppId: id,
        userId: data.public ? PUBLIC_ID : usr.id,
        comId: user.comId,
        role: truncate(data.role, 150),
        info: truncate(data.info, 150),
        location: truncate(data.location, 150),
        username: data.public ? "PUBLIC" : usr.username,
        lat: data.lat,
        lng: data.lng,
        startAt,
        stopAt,
        deleted: false,
        accepted: false,
        suspended: false, // data.suspended,
        confirmed: false, // data.confirmed, // false
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      }});
      setToastStatus("bg-success");
      setToastTitle('');
      setToastMessage(t('toast.openShiftCreated'));
      setShowToast(true);

      if (data.public) {
        sendTopicNotification(data.role ?? undefined, data.location ?? undefined, undefined, PUBLIC_ID, id ?? undefined, startAt, stopAt, "openShift", `${user.comId}_posts`, true);
      } else {
        if (usr.id !== AuthUserId) {
          sendTopicNotification(data.role ?? undefined, data.location ?? undefined, user.FCMtoken ?? undefined, usr.id ?? undefined, id ?? undefined, startAt, stopAt, "openShift");
        }
      }
      refetchShift();
    } catch (error) {
      console.log('error', (error as Error).message);
    } 
  }

  const creatingShift = (event: any) => {
    console.log('EVENT', event.added);
    if (event.added.public) {
      const shiftId = generateCustomId();
      shiftCreation(shiftId, event.added, "");
    } else {
      event.added.users.forEach((usr: any) => {
        const shiftId = generateCustomId();
        shiftCreation(shiftId, event.added, usr);
      });
    }
  }

  const usersOptions: { id: string; username: string }[] = [];
  // [
  //   {
  //     id: 1,
  //     name: 'Leanne Graham'
  //   },
  //   {
  //     id: 2,
  //     name: 'Ervin Howell'
  //   }
  // ];
  // users ? 
  //   users.map((usr: AgendaUser) => ({
  //     id: usr.userId,
  //     username: usr.username
  //   }))
  // : [];

  const appointmentForm = connectProps(AppointmentFormCustom, () => {
    const {
      editingFormVisible,
      editingAppointment,
      data,
      addedAppointment,
      isNewAppointment,
      previousAppointment,
      selectOptions,
      isMulti,
      removeConfirm,
      removePublic,
    } = form;
    // console.log('DATA', data);
    const currentAppointment = data
        .filter(appointment => editingAppointment && appointment.id === editingAppointment.id)[0]
        || addedAppointment;
    const cancelAppointment = () => {
      if (isNewAppointment) {
        setForm((prevState) => ({...prevState, 
          editingAppointment: previousAppointment,
          isNewAppointment: false
        }));
      }
    };

    return {
      visible: editingFormVisible,
      appointmentData: currentAppointment,
      commitChanges: form.creatingForm ? creatingShift : updatingShift,//commitChanges, //() => "", //this.commitChanges,
      visibleChange: toggleEditingFormVisibility, // () => ""
      onEditingAppointmentChange: creatingShift, //() => "", //this.onEditingAppointmentChange,
      cancelAppointment,
      selectOptions: usersOptions,
      isMulti: isMulti,
      removeConfirm: true,
      removePublic: removePublic,
    };
  });

  const openEditingForm = (appointment: any) => {
    setForm((prevState) => ({...prevState,
      editingFormVisible: true,
      editingAppointment: appointment, // Définit l'appointment actif
      creatingForm: false,
      isMulti: false,
      removePublic: false,
    }));
    // setToolTip({ visible: false });
    removeToolTip();
    
  };

  const removeToolTip = () => {
    // setToolTip({ visible: !toolTip.visible });
    const body = document.body.removeAttribute('style');
    const root = document.getElementById('root').removeAttribute('aria-hidden');

    const presentation = document.querySelector('.MuiBackdrop-root');
    (presentation as HTMLElement).click();
  };

  // Composant personnalisé du ViewSwitcher
  const CustomViewSwitcher = ({ onChange, availableViews }: ViewSwitcherBase.SwitcherProps) => {
    // Définition des labels personnalisés
    const customLabels = {
      Day: t('scheduler.day'),
      Week: t('scheduler.week'),
      Month: t('scheduler.month'),
    };
    // console.log('AVAIL', availableViews);
    return (
      <ToggleButtonGroup
        value={state.currentViewName}
        exclusive
        onChange={(_, newView) => newView && onChange(newView)}
        aria-label="Select a view"
      >
        {availableViews.map((view) => (
          <ToggleButton key={view.name} value={view.name}>
            {customLabels[view.name as keyof typeof customLabels] || view.displayName}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  };

  // drag
  // const dragDisableIds = new Set([3, 8, 10, 12]);
  // const allowDrag = (id: any) => !dragDisableIds.has(id);
  
  // const { data, currentDate, currentViewName, currentPriority, resources} = state;
  // const DraftAppointment = ({ data, ...restProps }: any) => (
  //   <Appointments.Appointment
  //     {...restProps}
  //     style={{
  //       backgroundColor: 'rgba(0, 123, 255, 0.7)',
  //       border: '2px dashed white',
  //     }}
  //   />
  // );

  // const SourceAppointment = ({ data, ...restProps }: any) => (
  //   <Appointments.Appointment
  //     {...restProps}
  //     style={{
  //       opacity: 0.5,
  //       backgroundColor: '#ffc107',
  //     }}
  //   />
  // );

  // const ResizeHandle = (props: any) => (
  //   <div
  //     {...props}
  //     style={{
  //       width: '10px',
  //       height: '100%',
  //       backgroundColor: 'maroon',
  //       cursor: 'ns-resize', //'ew-resize',
  //       position: 'absolute',
  //       right: 0,
  //       top: 0,
  //     }}
  //   />
  // );

  // const allowDrag = ({ id }) => !dragDisableIds.has(id);
  const allowDrag = (appointmentData: any) => {
    // console.log('LOL',appointmentData);
    // Exemple : empêcher le drag pour les événements passés
    return new Date(appointmentData.startDate) > new Date();
  };

  // const allowResize = (appointmentData: any) => {
  //   // console.log('LOL',appointmentData);
  //   // Exemple : empêcher le drag pour les événements passés
  //   return new Date(appointmentData.startDate) > new Date();
  // };

  // const CustomContainer = ({ children, ...restProps }: any) => {
  //   console.log('LOL',children);
  //   // Exclure des props non valides pour le DOM
  //   const { appointmentType, ...validProps } = restProps;
  
  //   return <div {...validProps}>{children}</div>;
  // };
  
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />

      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50 text-center">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}</strong></Toast.Body>
        </Toast>
      </ToastContainer>
            
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <div className="scheduler-container">
            <h2 style={{paddingTop:10, paddingLeft: 100}}>{t('home.manageOpenShift')}</h2>
          {/* <UserImage user={user} avatarStyle={{width: '100px', height: '100px', borderRadius: '50px'}}/> */}
          <Paper>
            <Scheduler
              data={filterTasks(state.data, state.currentPriority)}
              height={700}
              // key={schedulerKey}
              locale={language}
              firstDayOfWeek={1}
            >
              <ViewState
                currentDate={state.currentDate}
                currentViewName={state.currentViewName}
                onCurrentViewNameChange={currentViewNameChange}
                onCurrentDateChange={currentDateChange}
              />
              <GroupingState
                grouping={grouping}
              />

              <DayView
                startDayHour={0}
                endDayHour={24}
                displayName="Day" // "Jour"
                // name="Day"
                timeTableCellComponent={DayViewTimeTableCell}
                dayScaleCellComponent={DayViewDayScaleCell}
                intervalCount={2}
              />
              <WeekView
                startDayHour={0}
                endDayHour={24}
                excludedDays={[]} // {[0, 6]}
                displayName="Week" // "Semaine"
                // name="Week"
                timeTableCellComponent={WeekViewTimeTableCell}
                dayScaleCellComponent={WeekViewDayScaleCell}
                // name="Timeline"
                // layoutComponent={WeekView.Layout}
                // timeTableCellComponent={CustomTimeTableCell}
                // dayScaleCellComponent={CustomDayScaleCell}
              />
              <AllDayPanel
                cellComponent={AllDayCell}
              />

              <Appointments 
                appointmentComponent={Appointment}
              />
              <Resources
                data={state.resources}
              />
              <IntegratedGrouping />

              <GroupingPanel
                cellComponent={GroupingPanelCell}
              />
              <Toolbar flexibleSpaceComponent={flexibleSpace} />
              {/* <Toolbar flexibleSpaceComponent={flexibleSpaceRef.current} /> */}
              <DateNavigator />

              <ViewSwitcher switcherComponent={CustomViewSwitcher}/>
              <EditingState 
                onCommitChanges={dragAndDropChanges}
              />
              <IntegratedEditing />
              <AppointmentTooltip
                headerComponent={(props) => <TooltipHeader {...props} onOpen={openEditingForm} toggleVisible={removeToolTip} deleteItem={verifyDeleteShift} />}
                contentComponent={TooltipContent}//(props) => <TooltipContent {...props} onOpen={openEditingForm} />}//TooltipContent}
                // visible={toolTip.visible}
                // onVisibilityChange={toggleToolTip}
                // showOpenButton
                // showCloseButton
                // showDeleteButton
              />
              <AppointmentForm
                overlayComponent={appointmentForm}
                // {(props) => (
                //   <AppointmentFormCustom {...props} selectOptions={usersOptions} />
                // )}//{appointmentForm}
                visible={form.editingFormVisible}
                onVisibilityChange={toggleEditingFormVisibility}
                // selectOptions={usersOptions}
                // commitChanges={() => updatingShift}
              />
              <DragDropProvider 
                  // allowDrag={allowDrag} 
                  // allowResize={allowResize}
                  // draftAppointmentComponent={DraftAppointment} 
                  // sourceAppointmentComponent={SourceAppointment} 
                  // resizeComponent={ResizeHandle} 
                  // containerComponent={CustomContainer}          
              />
              
            </Scheduler>

            <Dialog
              open={form.confirmationVisible}
              onClose={toggleConfirmationVisible} //cancelDelete}
            >
              <DialogTitle>
                {t('scheduler.deleteShiftTitle')}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                {t('scheduler.deleteShiftMessage')}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={toggleConfirmationVisible} color="primary" variant="outlined">
                  Cancel
                </Button>
                <Button onClick={commitDeletedAppointment} color="secondary" variant="outlined">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            <StyledFab
              color="secondary"
              className={classes.addButton}
              onClick={() => {
                setForm((prevState) => ({...prevState, creatingForm: true, editingFormVisible: true, isMulti: true, removePublic: false }));
                onEditingAppointmentChange(undefined);
                onAddedAppointmentChange({
                  startDate: new Date(state.currentDate).setHours(form.startDayHour),
                  endDate: new Date(state.currentDate).setHours(form.startDayHour + 1),
                });
              }}
            >
              <AddIcon />
            </StyledFab>
          </Paper>
          {/* <div className="pagination-container"> */}
            {/* <p>tokenLenght: {pageTokens.length}</p>
            <p>pageIndex: {currentPageIndex}</p>
            <p>hasMorePages: {hasMorePages.toString()}</p>
            <p>currentPageIndex: {currentPageIndex}</p> */}
            {/* <h2 className="paginationTitle">{t('title.users')}</h2>
            
            <Pagination
              currentPage={currentPageIndex}
              totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
              hasMorePages={hasMorePages}
              onNext={handleNextPage}
              // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
              onPrevious={handlePreviousPage}
              onChange={handlePageChange}
              // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
              // showFirstLast
            />
          </div> */}

          {/* Formulaire pour aller à une page spécifique */}
          {/* <div>
            <input
              type="number"
              min={1}
              value={page}
              onChange={(e) => setPage(Number(e.target.value))}
              style={{ marginRight: "10px" }}
            />
            <button onClick={() => goToPage(page)} disabled={loadingUsers}>
              Go to page
            </button>
          </div> */}
        </div>
      </div>
    </div>
  </>
  );
};
// }

// const styles = {
//   spinner: {
//     // display: 'flex',
//     /* align-self: center;
//     align-items: center;
//     justify-content: center;
//     margin: 0 auto;
//     margin: 0 auto; */
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//   }
// };

export default SchedulerView;


